import { DialogBody, DialogHeader } from "components/common/dialogs/GenericDialog";
import { useLocale } from "lib/hooks/useLocale";
import React, { useState } from "react";
import GenericButton from "components/common/buttons/GenericButton";
import { PaymentStatusType } from "lib/types/payments";
import OverlaySpinner from "components/common/loaders/OverlaySpinner";
import { X } from "@phosphor-icons/react";
import { analyticsEvents } from "lib/utils/constants";
import useSendAnalyticsEvent from "lib/hooks/useAnalytics";

interface PaymentCancelProps {
  setIsOpen: (value: boolean) => void;
  handlePaymentCancel: (status: PaymentStatusType, paymentStatus?: any) => Promise<void>;
}

const PaymentCancel: React.FC<PaymentCancelProps> = ({ setIsOpen, handlePaymentCancel }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { t } = useLocale();

  const { sendAnalyticsEvent } = useSendAnalyticsEvent();

  const handleCancelClick = async () => {
    try {
      setIsLoading(true);
      sendAnalyticsEvent({
        eventName: analyticsEvents.FLO_PAYMENT_CANCEL_CONFIRMATION,
        eventType: "click",
      });
      await handlePaymentCancel("PAYMENT_CANCELLED", { status: "PAYMENT_CANCELLED" });
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <DialogHeader>
        <div className="flex h-full w-full flex-row items-center justify-between py-4">
          <h1 className="text-base font-medium">{t("cancel_payment_header")}</h1>
          <button className="outline-none">
            <X className="h-5 w-5 cursor-pointer text-coal-dark" onClick={() => setIsOpen(false)} />
          </button>
        </div>
      </DialogHeader>
      <DialogBody>
        <div className="relative flex w-full flex-col space-y-4 px-6 pt-8 pb-4">
          <GenericButton
            buttonText={t("yes")}
            height="h-14"
            customClass="bg-[#E06F39] rounded-2xl text-white"
            onClick={handleCancelClick}
          />

          <GenericButton
            buttonText={t("no")}
            height="h-14"
            customClass="border-2 rounded-2xl text-coal-dark"
            onClick={() => setIsOpen(false)}
          />
        </div>
      </DialogBody>
      {isLoading && <OverlaySpinner />}
    </>
  );
};
export default PaymentCancel;
